import React, { useMemo } from "react";
import isEmpty from "lodash/isEmpty";
import useWindowDimensions from "hooks/useWindowDimensions";
import { formatLowCount } from "utils/formatter";
import EyeIcon from "images/eye-icon.svg";
import PlayButtonIcon from "images/play-button-icon.svg";
import LocationDetails from "./LocationDetails";
import styles from "./MobileFullWidthReviewCard.module.css";

const ASPECT_RATIO = 1.25;

/**
 * This component is used when we don't want to show a review card in horizontal carousel,
 * but want to show a single review card in full width at a time
 * */
const MobileFullWidthReviewCard = ({
  review,
  onAuthorClick,
  onClick,
  showReadCount = true,
  showAddress = false,
  showAuthor = false,
  showTags = false
}) => {
  const { width } = useWindowDimensions();
  const { video, location } = review || {};

  const readCountLabel = useMemo(() =>
    formatLowCount(video?.clm_read_count)
  , [video?.clm_read_count]);

  return (
    <div
      className={styles.reviewCardContainer}
      style={{
        width: "100%"
      }}
      onClick={onClick}
    >
      <img
        alt={location?.clm_name}
        src={video?.urls?.poster}
        className={styles.reviewCardPoster}
        style={{
          width: "100%",
          height: width * ASPECT_RATIO
        }}
      />
      {showReadCount && readCountLabel && (
        <div className={styles.viewCountContainer}>
          <img src={EyeIcon} alt="View count" style={{ width: 16, height: 16 }}/>
          <span className={styles.overlayLabel}>{readCountLabel}</span>
        </div>
      )}
      <img
        src={PlayButtonIcon}
        alt="Play button"
        className={styles.overlayPlayIcon}
        style={{
          width: 72,
          height: 72,
          top: width * ASPECT_RATIO / 2
        }}
      />
      {!isEmpty(location) && (
        <LocationDetails
          location={location}
          showAddress={showAddress}
          showAuthor={showAuthor}
          showTags={showTags}
          author={review?.author}
          onAuthorClick={onAuthorClick}
        />
      )}
    </div>
  )
};

export default MobileFullWidthReviewCard;